import {
  Offer,
  OfferPriceVisibility,
  SetOfferContractTermsRequest,
} from "@/services/backend/qpm/offers/types/offer";
import {
  ContractTermMode,
  IoTAdditionalTrapRentMode,
} from "@/services/backend/qpm/offers/types/offer-enum";

export function defaultContractTermText(mode: ContractTermMode): string {
  switch (mode) {
    case ContractTermMode.Unlimited:
      return "Der Vertrag ist unbefristet.";
    case ContractTermMode.TwoPlusOne:
      return "Der Vertrag hat eine Grundlaufzeit von 2 Jahren und wird automatisch um 1 Jahr verlängert, wenn nicht vorher gekündigt.";
    case ContractTermMode.ThreePlusOne:
      return "Der Vertrag hat eine Grundlaufzeit von 3 Jahren und wird automatisch um 1 Jahr verlängert, wenn nicht vorher gekündigt.";
    case ContractTermMode.ByMainContract:
      return "Die Vertragserweiterung zum Schutz vor Schädlingen richtet sich nach dem bestehenden Hauptvertrag.";
    case ContractTermMode.ByFrameworkContract:
      return "Die Vertragserweiterung zum Schutz vor Schädlingen richtet sich nach dem bestehenden Rahmenvertrag.";
    default:
      return "";
  }
}

export function createSetContractTermsRequestFromOffer(
  offer: Offer,
): SetOfferContractTermsRequest {
  const contractTermText =
    offer.contractTermText?.trim() ||
    offer.contractTermUnlimitedText?.trim() ||
    defaultContractTermText(offer.contractTermMode);

  const priceVisibility: OfferPriceVisibility = offer.priceVisibility ?? {
    material: { qpm: true, fiv: true, aLoRa: true },
    installation: { qpm: true, fiv: true, aLoRa: true },
    maintenance: {
      qpm: true,
      fiv: true,
      scb: true,
      aLoRa: offer.includeIoTCheckpointServiceInQpm ?? false,
    },
    renting: { aLoRa: true },
  };

  return {
    offerId: offer.id,
    contractStartMode: offer.contractStartMode,
    contractStartDate: offer.contractStartDate,
    contractTermMode: offer.contractTermMode,
    contractTermText,
    contractTermUnlimitedText: contractTermText,
    contractTermTextSeparate: offer.contractTermTextSeparate ?? false,
    contractTermContractText: offer.contractTermContractText ?? "",
    contractAdditionalText: offer.contractAdditionalText ?? "",
    contractSpecialAgreementUseDate:
      offer.contractSpecialAgreementUseDate ?? true,
    contractSpecialAgreementText: offer.contractSpecialAgreementText ?? "",
    ioTAdditionalTrapRentEnabled: offer.ioTAdditionalTrapRentEnabled ?? false,
    ioTAdditionalTrapRentMode:
      offer.ioTAdditionalTrapRentMode ?? IoTAdditionalTrapRentMode.General,
    ioTAdditionalTrapRentPrice: Math.max(
      0,
      offer.ioTAdditionalTrapRentPrice ?? 0,
    ),
    ioTAdditionalTrapRentMonitorIds: [
      ...(offer.ioTAdditionalTrapRentMonitorIds ?? []),
    ],
    includeIoTCheckpointServiceInQpm:
      offer.includeIoTCheckpointServiceInQpm ?? false,
    priceVisibility,
  };
}
